// AUTO-GENERATED — do NOT edit by hand.
// Regenerated at every `yarn start` / `yarn build` from write-build-info.js.
// v200.41 · source: SHA-256(src/**/{.js,.jsx,.ts,.tsx,.css} + yarn.lock),
// deterministic path order. No env, no git, no asset-manifest.
export const APP_VERSION       = "vc37a850c9280-2026-11-03T18:27";
export const APP_BUILD_DATE    = "2026-11-03";
export const APP_BUILD_TIME    = "2026-11-03T18:27:52.549Z";
export const APP_BUILD_MINUTE  = "2026-11-03T18:27";
export const APP_GIT_COMMIT    = "c37a850c9280";
export const APP_COMMIT_SOURCE = "src+lock";
